import { useEffect, useState } from 'react';

function TestimonialBanner() {
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    setFadeIn(true);
  }, []);

  return (
    <>
      <div className={`w-full h-auto relative bg-gradient-to-r from-gray-900 via-gray-800 to-black text-white transition-opacity duration-1000 ${fadeIn ? 'opacity-100' : 'opacity-0'}`}>
        <div className="absolute inset-0 flex justify-center items-center">
          <h1 className="text-[10rem] font-bold text-white opacity-10 animate-bounceIn">TESTIMONIAL</h1>
        </div>
        <div className="relative container mx-auto px-4 py-28 z-10 space-y-12">
          {/* DURAI's Testimonial */}
          <div className="p-8 bg-gray-800 bg-opacity-70 rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105 animate-slideInLeft delay-100">
            <h2 className="text-4xl font-bold mb-2 animate-zoomIn">DURAI</h2>
            <div className="flex items-center mb-4 animate-fadeInUp delay-200">
              <span>⭐⭐⭐⭐⭐</span>
              <span className="ml-2">💪🏋‍♂</span>
            </div>
            <p className="text-lg animate-fadeInUp delay-300">
              Spacious gym with excellent training. Special weight sessions available.
            </p>
          </div>

          {/* MOHAMED's Testimonial */}
          <div className="p-8 bg-gray-800 bg-opacity-70 rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105 animate-slideInRight delay-200">
            <h2 className="text-4xl font-bold mb-2 animate-zoomIn">MOHAMED</h2>
            <div className="flex items-center mb-4 animate-fadeInUp delay-300">
              <span>⭐⭐⭐⭐⭐</span>
              <span className="ml-2">👍💯</span>
            </div>
            <p className="text-lg animate-fadeInUp delay-400">
              An excellent gym in Parrys with very good training.
            </p>
          </div>

          {/* BALAJI's Testimonial */}
          <div className="p-8 bg-gray-800 bg-opacity-70 rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105 animate-slideInLeft delay-300">
            <h2 className="text-4xl font-bold mb-2 animate-zoomIn">BALAJI</h2>
            <div className="flex items-center mb-4 animate-fadeInUp delay-400">
              <span>⭐⭐⭐⭐⭐</span>
              <span className="ml-2">🏋‍♀💸</span>
            </div>
            <p className="text-lg animate-fadeInUp delay-500">
              Excellent place and space for gym, good trainers, good atmosphere, reasonable annual package. Value for money. Don't miss it.
            </p>
          </div>

          {/* JOYCE's Testimonial */}
          <div className="p-8 bg-gray-800 bg-opacity-70 rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105 animate-slideInRight delay-400">
            <h2 className="text-4xl font-bold mb-2 animate-zoomIn">JOYCE</h2>
            <div className="flex items-center mb-4 animate-fadeInUp delay-500">
              <span>⭐⭐⭐⭐⭐</span>
              <span className="ml-2">🏆🎯</span>
            </div>
            <p className="text-lg animate-fadeInUp delay-600">
              Very good gym in Parrys. They encourage and conduct competitions. Certified trainers.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default TestimonialBanner;
